<div class="dialogContent">
  <mat-toolbar color="primary">
    <div fxFlex>انتخاب استان</div>
    <button mat-icon-button (click)="dialogRef.close()"><mat-icon>close</mat-icon></button>
  </mat-toolbar>
  <mat-card-content>

    <div fxLayout="row wrap" class="pa-10">
      <div *ngFor="let pr of allProvinces" fxFlex="33.33333" fxFlex.lt-sm="100" class="provinces">
        <mat-checkbox (change)="changeSelectedProvincesList(pr.province,$event);" [checked]="pr.isSelected"></mat-checkbox>
        <span class="mr-5" *ngIf="pr.province">{{pr.province.provincePersianTitle}}</span>
      </div>
    </div>

  </mat-card-content>
  <div class="center mb-10 mt-10">
  <button mat-raised-button class="confirmBranch" color="primary" (click)="dialogRef.close(selectedProvinces);">اعمال فیلتر استان </button>
  </div>
</div>
